module.exports = __webpack_public_path__ + "static/media/stars.68ed63f2.png";